module.exports = __webpack_public_path__ + "static/media/photo3.6c0975b6.jpg";